import React from 'react'
import {withNav} from '../../../core/components/navbar/index'
import {connect} from 'react-redux'
import {VisibleLoginForm} from '../../../core/components/modals/login-and-register/LoginForm'
import {selectUserInfo} from '../../../redux/modules/session'
import {Redirect} from 'react-router'
import Box from '../../../core/components/box/Box'

class StandaloneLogin extends React.PureComponent {

  render() {
    const {isLoggedIn} = this.props
    if (isLoggedIn) {
      return <Redirect to='/' />
    }
    return (
      <Box display='flex' justifyContent='center' color='white' paddingY={12}>
        <VisibleLoginForm />
      </Box>
    )
  }
}

const mapStateToProps = state => {
  const userInfo = selectUserInfo(state)
  return {
    isLoggedIn: userInfo.isLoggedIn
  }
}
export default connect(
  mapStateToProps
)(withNav(StandaloneLogin))



// WEBPACK FOOTER //
// ./src/domains/misc/components/StandaloneLogin.js